module.exports = __webpack_public_path__ + "img/VALOR_CONFIANZA1.e45c499c.png";